import { render, staticRenderFns } from "./AddUnderWritingQuestion.vue?vue&type=template&id=40b64a8a"
import script from "./AddUnderWritingQuestion.vue?vue&type=script&lang=ts"
export * from "./AddUnderWritingQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports